export default __webpack_public_path__ + "static/use@mob-b10be9362e0a3667eff26466c452043f.webp";